import Grid from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles';
import React from 'react';

export const MenuBar = (props) => {

  const labelStyle = {
    paddingRight: '40px',
    paddingLeft: '40px',
    paddingBottom: '12px',
    whiteSpace: 'nowrap',
  };
  const theme = useTheme();

  const StyledMenuGrid = styled(Grid)(() => ({
    backgroundColor: theme.palette.background.secondary,
    padding: 5,
    'ul.nav': {
      width: '100%'
    },
    'p': {
      color: 'white',
      textShadow: '1px 1px 1px rgba(0, 0, 0, 0.3)',
    },
    'ul > p': {
      paddingTop: '15px',
      ...labelStyle
    },
    '.nav-link': {
      paddingTop: '12px',
      ...labelStyle
    },
  }));

  return (
    <StyledMenuGrid container>
      { props.children }
    </StyledMenuGrid>
  );
}